import _defineProperty from "/home/maxwell/maxwell-sms-shopify-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/home/maxwell/maxwell-sms-shopify-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/maxwell/maxwell-sms-shopify-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/maxwell/maxwell-sms-shopify-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/maxwell/maxwell-sms-shopify-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/maxwell/maxwell-sms-shopify-app/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component, createRef } from 'react';
import { SearchMinor, CancelSmallMinor, ChevronUpMinor, ChevronDownMinor } from '@shopify/polaris-icons';
import { classNames } from '../../utilities/css.js';
import { focusFirstFocusableNode } from '../../utilities/focus.js';
import { WithinFilterContext } from '../../utilities/within-filter-context.js';
import { Key } from '../../types.js';
import styles from './Filters.scss.js';
import { Collapsible } from '../Collapsible/Collapsible.js';
import { ConnectedFilterControl } from './components/ConnectedFilterControl/ConnectedFilterControl.js';
import { TagsWrapper } from './components/TagsWrapper/TagsWrapper.js';
import { Tag } from '../Tag/Tag.js';
import { Sheet } from '../Sheet/Sheet.js';
import { ResourceListContext } from '../../utilities/resource-list/context.js';
import { useI18n } from '../../utilities/i18n/hooks.js';
import { useMediaQuery } from '../../utilities/media-query/hooks.js';
import { ScrollLock } from '../ScrollLock/ScrollLock.js';
import { Badge } from '../Badge/Badge.js';
import { TextStyle } from '../TextStyle/TextStyle.js';
import { Icon } from '../Icon/Icon.js';
import { Focus } from '../Focus/Focus.js';
import { Button } from '../Button/Button.js';
import { TextField } from '../TextField/TextField.js';
import { DisplayText } from '../DisplayText/DisplayText.js';
import { Scrollable } from '../Scrollable/Scrollable.js';
import { KeypressListener } from '../KeypressListener/KeypressListener.js';
import { Stack } from '../Stack/Stack.js';
var Suffix;

(function (Suffix) {
  Suffix["Filter"] = "Filter";
  Suffix["Shortcut"] = "Shortcut";
})(Suffix || (Suffix = {}));

var FiltersInner =
/*#__PURE__*/
function (_Component) {
  _inherits(FiltersInner, _Component);

  function FiltersInner() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, FiltersInner);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(FiltersInner)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      open: false,
      readyForFocus: false
    };
    _this.moreFiltersButtonContainer =
    /*#__PURE__*/
    createRef();
    _this.moreFiltersDoneButtonContainer =
    /*#__PURE__*/
    createRef();
    _this.focusNode =
    /*#__PURE__*/
    createRef();

    _this.closeFilters = function () {
      _this.setState({
        open: false
      }, function () {
        if (_this.moreFiltersButtonContainer.current) {
          focusFirstFocusableNode(_this.moreFiltersButtonContainer.current, false);
        }
      });
    };

    _this.toggleFilters = function () {
      if (_this.state.open === true) {
        _this.closeFilters();
      } else {
        _this.openFilters();
      }
    };

    _this.setReadyForFocus = function (newState) {
      return function () {
        _this.setState({
          readyForFocus: newState
        });
      };
    };

    _this.handleClearAll = function () {
      _this.props.onClearAll();

      _this.moreFiltersDoneButtonContainer.current && focusFirstFocusableNode(_this.moreFiltersDoneButtonContainer.current, false);
    };

    return _this;
  }

  _createClass(FiltersInner, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          filters = _this$props.filters,
          queryValue = _this$props.queryValue,
          onQueryBlur = _this$props.onQueryBlur,
          onQueryChange = _this$props.onQueryChange,
          onQueryFocus = _this$props.onQueryFocus,
          focused = _this$props.focused,
          onClearAll = _this$props.onClearAll,
          appliedFilters = _this$props.appliedFilters,
          onQueryClear = _this$props.onQueryClear,
          queryPlaceholder = _this$props.queryPlaceholder,
          children = _this$props.children,
          _this$props$disabled = _this$props.disabled,
          disabled = _this$props$disabled === void 0 ? false : _this$props$disabled,
          helpText = _this$props.helpText,
          hideTags = _this$props.hideTags,
          hideQueryField = _this$props.hideQueryField,
          i18n = _this$props.i18n,
          isNavigationCollapsed = _this$props.mediaQuery.isNavigationCollapsed;
      var resourceName = this.context.resourceName;
      var _this$state = this.state,
          open = _this$state.open,
          readyForFocus = _this$state.readyForFocus;
      var backdropMarkup = open ?
      /*#__PURE__*/
      React.createElement(React.Fragment, null,
      /*#__PURE__*/
      React.createElement(ScrollLock, null),
      /*#__PURE__*/
      React.createElement("div", {
        className: styles.Backdrop,
        onClick: this.closeFilters
      })) : null;
      var filtersContentMarkup = filters.map(function (filter, index) {
        var filterIsOpen = _this2.state["".concat(filter.key).concat(Suffix.Filter)] === true;
        var icon = filterIsOpen ? ChevronUpMinor : ChevronDownMinor;
        var className = classNames(styles.FilterTriggerContainer, filterIsOpen && styles.open, index === 0 && styles.first, filters.length !== 1 && index === filters.length - 1 && styles.last);

        var appliedFilterContent = _this2.getAppliedFilterContent(filter.key);

        var appliedFilterBadgeMarkup = appliedFilterContent ?
        /*#__PURE__*/
        React.createElement("div", {
          className: styles.AppliedFilterBadgeContainer
        },
        /*#__PURE__*/
        React.createElement(Badge, {
          size: "small",
          status: "new"
        }, appliedFilterContent)) : null;
        var collapsibleID = "".concat(filter.key, "Collapsible");
        var buttonClassName = classNames(styles.FilterTrigger);
        return (
          /*#__PURE__*/
          React.createElement("div", {
            key: filter.key,
            className: className
          },
          /*#__PURE__*/
          React.createElement("button", {
            onClick: function onClick() {
              return _this2.toggleFilter(filter.key);
            },
            className: buttonClassName,
            id: "".concat(filter.key, "ToggleButton"),
            type: "button",
            "aria-controls": collapsibleID,
            "aria-expanded": filterIsOpen
          },
          /*#__PURE__*/
          React.createElement("div", {
            className: styles.FilterTriggerLabelContainer
          },
          /*#__PURE__*/
          React.createElement("h3", {
            className: styles.FilterTriggerTitle
          },
          /*#__PURE__*/
          React.createElement(TextStyle, {
            variation: _this2.props.disabled || filter.disabled ? 'subdued' : undefined
          }, filter.label)),
          /*#__PURE__*/
          React.createElement("span", {
            className: styles.FilterTriggerIcon
          },
          /*#__PURE__*/
          React.createElement(Icon, {
            source: icon,
            color: "base"
          }))), appliedFilterBadgeMarkup),
          /*#__PURE__*/
          React.createElement(Collapsible, {
            id: collapsibleID,
            open: filterIsOpen
          },
          /*#__PURE__*/
          React.createElement("div", {
            className: styles.FilterNodeContainer
          },
          /*#__PURE__*/
          React.createElement(Focus, {
            disabled: !filterIsOpen || !readyForFocus || !open,
            root: _this2.focusNode
          }, _this2.generateFilterMarkup(filter)))))
        );
      });
      var appliedFiltersCount = appliedFilters ? appliedFilters.length : 0;
      var moreFiltersLabel = hideTags && appliedFiltersCount > 0 ? i18n.translate('Polaris.Filters.moreFiltersWithCount', {
        count: appliedFiltersCount
      }) : i18n.translate('Polaris.Filters.moreFilters');
      var rightActionMarkup = filters.length ?
      /*#__PURE__*/
      React.createElement("div", {
        ref: this.moreFiltersButtonContainer
      },
      /*#__PURE__*/
      React.createElement(Button, {
        onClick: this.toggleFilters,
        disabled: disabled
      }, moreFiltersLabel)) : null;
      var filterResourceName = resourceName || {
        singular: i18n.translate('Polaris.ResourceList.defaultItemSingular'),
        plural: i18n.translate('Polaris.ResourceList.defaultItemPlural')
      };
      var transformedFilters = this.transformFilters(filters);
      var filtersControlMarkup =
      /*#__PURE__*/
      React.createElement(ConnectedFilterControl, {
        rightPopoverableActions: transformedFilters,
        rightAction: rightActionMarkup,
        auxiliary: children,
        disabled: disabled,
        forceShowMorefiltersButton: filters.length > transformedFilters.length,
        queryFieldHidden: hideQueryField
      }, hideQueryField ? null :
      /*#__PURE__*/
      React.createElement(TextField, {
        placeholder: queryPlaceholder || i18n.translate('Polaris.Filters.filter', {
          resourceName: filterResourceName.plural
        }),
        onChange: onQueryChange,
        onBlur: onQueryBlur,
        onFocus: onQueryFocus,
        value: queryValue,
        focused: focused,
        label: queryPlaceholder || i18n.translate('Polaris.Filters.filter', {
          resourceName: filterResourceName.plural
        }),
        labelHidden: true,
        prefix:
        /*#__PURE__*/
        React.createElement("span", {
          className: styles.SearchIcon
        },
        /*#__PURE__*/
        React.createElement(Icon, {
          source: SearchMinor
        })),
        clearButton: true,
        onClearButtonClick: onQueryClear,
        disabled: disabled,
        autoComplete: "off"
      }));
      var filtersContainerHeaderClassname = classNames(styles.FiltersContainerHeader);
      var filtersDesktopHeaderMarkup =
      /*#__PURE__*/
      React.createElement("div", {
        className: filtersContainerHeaderClassname
      },
      /*#__PURE__*/
      React.createElement(DisplayText, {
        size: "small",
        element: "h3"
      }, moreFiltersLabel),
      /*#__PURE__*/
      React.createElement(Button, {
        icon: CancelSmallMinor,
        plain: true,
        accessibilityLabel: i18n.translate('Polaris.Filters.cancel'),
        onClick: this.closeFilters
      }));
      var filtersMobileHeaderMarkup =
      /*#__PURE__*/
      React.createElement("div", {
        className: filtersContainerHeaderClassname
      },
      /*#__PURE__*/
      React.createElement(Button, {
        icon: CancelSmallMinor,
        plain: true,
        accessibilityLabel: i18n.translate('Polaris.Filters.cancel'),
        onClick: this.closeFilters
      }),
      /*#__PURE__*/
      React.createElement(DisplayText, {
        size: "small",
        element: "h3"
      }, moreFiltersLabel),
      /*#__PURE__*/
      React.createElement(Button, {
        onClick: this.closeFilters,
        primary: true
      }, i18n.translate('Polaris.Filters.done')));
      var filtersDesktopFooterClassname = classNames(styles.FiltersContainerFooter);
      var filtersDesktopFooterMarkup =
      /*#__PURE__*/
      React.createElement("div", {
        className: filtersDesktopFooterClassname
      },
      /*#__PURE__*/
      React.createElement(Button, {
        onClick: this.handleClearAll,
        disabled: !this.hasAppliedFilters()
      }, i18n.translate('Polaris.Filters.clearAllFilters')),
      /*#__PURE__*/
      React.createElement("div", {
        ref: this.moreFiltersDoneButtonContainer
      },
      /*#__PURE__*/
      React.createElement(Button, {
        onClick: this.closeFilters,
        primary: true
      }, i18n.translate('Polaris.Filters.done'))));
      var filtersMobileFooterMarkup =
      /*#__PURE__*/
      React.createElement("div", {
        className: styles.FiltersMobileContainerFooter
      }, this.hasAppliedFilters() ?
      /*#__PURE__*/
      React.createElement(Button, {
        onClick: onClearAll,
        fullWidth: true
      }, i18n.translate('Polaris.Filters.clearAllFilters')) :
      /*#__PURE__*/
      React.createElement("div", {
        className: styles.EmptyFooterState
      },
      /*#__PURE__*/
      React.createElement(TextStyle, {
        variation: "subdued"
      },
      /*#__PURE__*/
      React.createElement("p", null, i18n.translate('Polaris.Filters.noFiltersApplied')))));
      var shouldHideTagsContainer = !appliedFilters || appliedFilters.length < 1;
      var tagsMarkup = !hideTags ?
      /*#__PURE__*/
      React.createElement(TagsWrapper, {
        hidden: shouldHideTagsContainer
      },
      /*#__PURE__*/
      React.createElement("div", {
        className: styles.TagsContainer,
        "aria-live": "polite"
      }, (appliedFilters || []).map(function (filter) {
        return (
          /*#__PURE__*/
          React.createElement(Tag, {
            key: filter.key,
            onRemove: function onRemove() {
              filter.onRemove(filter.key);
            },
            disabled: disabled
          }, filter.label)
        );
      }))) : null;
      var filtersMobileContainerContentClassName = classNames(styles.FiltersMobileContainerContent);
      var filtersDesktopContainerContentClassName = classNames(styles.FiltersDesktopContainerContent);
      var filtersContainerMarkup = isNavigationCollapsed ?
      /*#__PURE__*/
      React.createElement(Sheet, {
        accessibilityLabel: moreFiltersLabel,
        open: open,
        onClose: this.closeFilters,
        onEntered: this.setReadyForFocus(true),
        onExit: this.setReadyForFocus(false)
      }, filtersMobileHeaderMarkup,
      /*#__PURE__*/
      React.createElement(Scrollable, {
        className: filtersMobileContainerContentClassName,
        shadow: true
      }, filtersContentMarkup, filtersMobileFooterMarkup)) :
      /*#__PURE__*/
      React.createElement(Sheet, {
        accessibilityLabel: moreFiltersLabel,
        open: open,
        onClose: this.closeFilters,
        onEntered: this.setReadyForFocus(true),
        onExit: this.setReadyForFocus(false)
      },
      /*#__PURE__*/
      React.createElement("div", {
        className: styles.FiltersContainer
      }, filtersDesktopHeaderMarkup,
      /*#__PURE__*/
      React.createElement(Scrollable, {
        className: filtersDesktopContainerContentClassName,
        shadow: true
      }, filtersContentMarkup), filtersDesktopFooterMarkup));
      var helpTextMarkup = helpText ?
      /*#__PURE__*/
      React.createElement("div", {
        id: "FiltersHelpText",
        className: styles.HelpText
      },
      /*#__PURE__*/
      React.createElement(TextStyle, {
        variation: "subdued"
      }, helpText)) : null;
      return (
        /*#__PURE__*/
        React.createElement(WithinFilterContext.Provider, {
          value: true
        },
        /*#__PURE__*/
        React.createElement("div", {
          className: styles.Filters
        }, filtersControlMarkup, filtersContainerMarkup, tagsMarkup, helpTextMarkup, backdropMarkup,
        /*#__PURE__*/
        React.createElement(KeypressListener, {
          keyCode: Key.Escape,
          handler: this.closeFilters
        })))
      );
    }
  }, {
    key: "hasAppliedFilters",
    value: function hasAppliedFilters() {
      var _this$props2 = this.props,
          appliedFilters = _this$props2.appliedFilters,
          queryValue = _this$props2.queryValue;
      var filtersApplied = Boolean(appliedFilters && appliedFilters.length > 0);
      var queryApplied = Boolean(queryValue && queryValue !== '');
      return filtersApplied || queryApplied;
    }
  }, {
    key: "getAppliedFilterContent",
    value: function getAppliedFilterContent(key) {
      var appliedFilters = this.props.appliedFilters;

      if (!appliedFilters) {
        return undefined;
      }

      var filter = appliedFilters.find(function (filter) {
        return filter.key === key;
      });
      return filter == null ? undefined : filter.label;
    }
  }, {
    key: "getAppliedFilterRemoveHandler",
    value: function getAppliedFilterRemoveHandler(key) {
      var appliedFilters = this.props.appliedFilters;

      if (!appliedFilters) {
        return undefined;
      }

      var filter = appliedFilters.find(function (filter) {
        return filter.key === key;
      });
      return filter == null ? undefined : filter.onRemove;
    }
  }, {
    key: "openFilters",
    value: function openFilters() {
      this.setState({
        open: true
      });
    }
  }, {
    key: "openFilter",
    value: function openFilter(key) {
      this.setState(_defineProperty({}, "".concat(key).concat(Suffix.Filter), true));
    }
  }, {
    key: "closeFilter",
    value: function closeFilter(key) {
      this.setState(_defineProperty({}, "".concat(key).concat(Suffix.Filter), false));
    }
  }, {
    key: "toggleFilter",
    value: function toggleFilter(key) {
      if (this.state["".concat(key).concat(Suffix.Filter)] === true) {
        this.closeFilter(key);
      } else {
        this.openFilter(key);
      }
    }
  }, {
    key: "openFilterShortcut",
    value: function openFilterShortcut(key) {
      this.setState(_defineProperty({}, "".concat(key).concat(Suffix.Shortcut), true));
    }
  }, {
    key: "closeFilterShortcut",
    value: function closeFilterShortcut(key) {
      this.setState(_defineProperty({}, "".concat(key).concat(Suffix.Shortcut), false));
    }
  }, {
    key: "toggleFilterShortcut",
    value: function toggleFilterShortcut(key) {
      if (this.state["".concat(key).concat(Suffix.Shortcut)] === true) {
        this.closeFilterShortcut(key);
      } else {
        this.openFilterShortcut(key);
      }
    }
  }, {
    key: "transformFilters",
    value: function transformFilters(filters) {
      var _this3 = this;

      var transformedActions = [];
      getShortcutFilters(filters).forEach(function (filter) {
        var key = filter.key,
            label = filter.label,
            disabled = filter.disabled;
        transformedActions.push({
          popoverContent: _this3.generateFilterMarkup(filter),
          popoverOpen: Boolean(_this3.state["".concat(key).concat(Suffix.Shortcut)]),
          key: key,
          content: label,
          disabled: disabled,
          onAction: function onAction() {
            return _this3.toggleFilterShortcut(key);
          }
        });
      });
      return transformedActions;
    }
  }, {
    key: "generateFilterMarkup",
    value: function generateFilterMarkup(filter) {
      var i18n = this.props.i18n;
      var removeCallback = this.getAppliedFilterRemoveHandler(filter.key);
      var removeHandler = removeCallback == null ? undefined : function () {
        removeCallback(filter.key);
      };
      var clearButtonMarkup = !filter.hideClearButton &&
      /*#__PURE__*/
      React.createElement(Button, {
        plain: true,
        disabled: removeHandler == null,
        onClick: removeHandler,
        accessibilityLabel: i18n.translate('Polaris.Filters.clearLabel', {
          filterName: filter.label
        })
      }, i18n.translate('Polaris.Filters.clear'));
      return (
        /*#__PURE__*/
        React.createElement("div", {
          ref: this.focusNode
        },
        /*#__PURE__*/
        React.createElement(Stack, {
          vertical: true,
          spacing: "tight"
        }, filter.filter, clearButtonMarkup))
      );
    }
  }]);

  return FiltersInner;
}(Component);

FiltersInner.contextType = ResourceListContext;

function getShortcutFilters(filters) {
  return filters.filter(function (filter) {
    return filter.shortcut === true;
  });
}

function Filters(props) {
  var i18n = useI18n();
  var mediaQuery = useMediaQuery();
  return (
    /*#__PURE__*/
    React.createElement(FiltersInner, Object.assign({}, props, {
      i18n: i18n,
      mediaQuery: mediaQuery
    }))
  );
}

export { Filters };